export { default as deleteDepartmentReducer } from './slice';
export { onDeleteDepartmentStart } from './saga';
